<template>
  <div class="triangle">
    <div class="triangle-ico dib ovh bsb" :class="[type]" :style="outStyle">
      <div class="flex jcc aic zi1" :style="{width: maxSize + 'px', height: maxSize + 'px'}">
        <span class="inner" :style="currStyle"></span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "TriangleIco",
    props: {
      type: {
        type: String,
        default: 'left',
      },
      size: {
        type: Number,
        default: 13,
      },
      color: {
        type: String,
        default: '#f00',
      },
      shadow: {
        type: Boolean | Number | String,
        default: 4,
      },
      shadowColor: String,
    },
    computed: {
      maxSize() {
        return this.size * (+(this.type === 'left' || this.type === 'right') + 1);
      },
      outStyle() {
        return {
          // [this.type === 'left' || this.type === 'right' ? 'paddingLeft' : 'paddingTop']: +this.shadow ? (this.shadow === true ? 2 : this.shadow) + 'px' : '',
          width: this.size + 'px',
          height: (this.type === 'left' || this.type === 'right' ? this.size * 2 : (this.size / 2)) + 'px',
        };
      },
      currStyle() {
        // let n = 2;
        let n = Math.sqrt(2);
        let {type, size, color, shadow, shadowColor} = this;
        let w = parseInt((type === 'left' || type === 'right' ? size * n : size / n) + '');
        let obj = {
          width: w + 'px',
          height: w + 'px',
          backgroundColor: color,
        };
        switch (typeof shadow) {
          case 'boolean':
            obj.boxShadow = shadow ? `0 0 2px ${shadowColor || color}` : '';
            break;
          case 'string':
          case 'number':
            obj.boxShadow = !isNaN(shadow) ? `0 0 ${shadow}px ${shadowColor || color}` : '';
            break;
        }
        return obj;
      },
    }
  }
</script>

<style scoped lang="less">

  .ml-auto {
    margin-left: auto;
  }

  .mr-auto {
    margin-right: auto;
  }

  .triangle {
    line-height: 0;
    .bottom {
      transform: rotateX(180deg);
    }
    .right {
      transform: rotateY(180deg);
    }
  }

  .inner {
    transform: rotate(45deg);
  }
</style>